import { useCallback } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service/index.tsx';
import type { StatusTransition } from '@atlassian/jira-issue-field-status/src/common/types.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { UseFetchTransitionsService } from './types.tsx';
import getTransitions from './utils/client.tsx';

type FetchTransitionsPromise = (payload: {
	projectId: string;
	issueTypeId: string;
	selectedCloudId?: string;
}) => Promise<StatusTransition[] | undefined>;

const useFetchTransitionsService: UseFetchTransitionsService = () => {
	const { cloudId } = useTenantContext();

	const fetchTransitions: FetchTransitionsPromise = useCallback(
		({ projectId, issueTypeId, selectedCloudId }) =>
			getTransitions(selectedCloudId || cloudId, projectId, issueTypeId),
		[cloudId],
	);
	const { loading, error, data, fetch } = useService(fetchTransitions);

	return [{ isLoading: loading, error, transitions: data }, fetch];
};

export default useFetchTransitionsService;
